(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1ee8dc1"] && !Shopify.designMode) return;
  try {
    // Hero images default to loading="lazy" so below-fold heroes don't compete
  // for bandwidth with the LCP. But native lazy's trigger threshold is too
  // tight on fast desktops — users see a blank slot for ~1 viewport scroll
  // before the next hero pops in. We widen the threshold to "1 viewport below"
  // by stripping the lazy attribute once an image enters that zone, which
  // makes the browser fetch right away.
  if (!window.__heroLazyApproachInit) {
    window.__heroLazyApproachInit = true;
    const setupHeroLazyApproach = () => {
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            const img = e.target;
            // Removing the loading attribute makes it eager — browser fetches now.
            img.removeAttribute('loading');
            // If a previous lazy state stopped srcset evaluation, kick it.
            if (img.dataset.heroSrcset && !img.srcset) img.srcset = img.dataset.heroSrcset;
            io.unobserve(img);
          }
        }
      }, { rootMargin: '0px 0px 100% 0px' });
      const observe = () => {
        document.querySelectorAll('img.ai-hero-banner__media[loading="lazy"], img.ai-hero-banner__video-poster[loading="lazy"]').forEach((img) => io.observe(img));
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observe, { once: true });
      } else {
        observe();
      }
    };
    setupHeroLazyApproach();
  }

  (function () {
    if (customElements.get('edge-to-edge-hero')) return;

    class EdgeToEdgeHero extends HTMLElement {
      constructor() {
        super();
        this.isHovering = false;
        this.isMobileExpanded = false;
      }

      connectedCallback() {
        this.videos = this.querySelectorAll('video');
        const shouldAutoplay = this.dataset.videoAutoplay === 'true';

        this.classList.toggle('video-click-to-play', !shouldAutoplay);

        const syncVideoOverlays = () => {
          if (shouldAutoplay) return;
          const wraps = this.querySelectorAll('[data-video-wrap]');
          let anyPlaying = false;
          wraps.forEach((wrap) => {
            // Target the MAIN video specifically — the cover loop is also a
            // <video> inside the same wrap and would otherwise be picked first.
            const v = wrap.querySelector('.ai-hero-banner__video');
            if (!v) return;
            const paused = v.paused || v.ended;
            wrap.classList.toggle('is-paused', paused);
            if (!paused) anyPlaying = true;
          });
          this.classList.toggle('video-playing', anyPlaying);
          // Sticky: once any video has played, hover-zone stays disabled so
          // the controls remain interactive even after the user pauses.
          if (anyPlaying) this.classList.add('video-engaged');
        };
        syncVideoOverlays();

        this.videos.forEach((v) => {
          // Cover loops play continuously and shouldn't drive engagement state.
          if (!v.classList.contains('ai-hero-banner__video')) return;
          v.addEventListener('play', syncVideoOverlays);
          v.addEventListener('pause', syncVideoOverlays);
          v.addEventListener('ended', syncVideoOverlays);
          v.addEventListener('loadeddata', syncVideoOverlays);
        });

        // Cover-loop swap: when the main click-to-play video actually starts
        // rendering frames (`playing` event, not `play`), hide the cover so
        // the swap happens between real frames — no black-frame flicker even
        // if the main video is mid-buffer when the user clicks.
        if (!shouldAutoplay) {
          this.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
            const cover = wrap.querySelector('.ai-hero-banner__cover-video');
            const main = wrap.querySelector('.ai-hero-banner__video');
            // .has-poster wraps also need .is-engaged to reveal the video.
            if (!main || (!cover && !wrap.classList.contains('has-poster'))) return;
            main.addEventListener('playing', () => {
              wrap.classList.add('is-engaged');
              if (cover) { try { cover.pause(); } catch (e) {} }
            }, { once: true });
          });
        }

        /* Autoplay handled by the lazy section manager in layout/theme.liquid.
           It starts muted-loop videos on first intersection so Safari doesn't
           pre-download them during HTML parse (preload=metadata is ignored when
           autoplay is declared on the element). */

        /* Click-to-start (2026-07-29): the play-icon overlay is decorative
           (pointer-events: none) and browsers don't reliably toggle playback
           on video-body clicks — Safari never does, Chrome ignores them while
           metadata is still loading. Before first engagement, any click on a
           click-to-play wrap explicitly starts the main video; the click is a
           real user gesture so play() with sound is permitted. After
           engagement the native controls own all clicks. */
        if (!shouldAutoplay) {
          this.addEventListener('click', (e) => {
            const wrap = e.target.closest('[data-video-wrap]');
            if (!wrap || !this.contains(wrap)) return;
            if (wrap.classList.contains('is-engaged')) return;
            const v = wrap.querySelector('.ai-hero-banner__video');
            /* Two guards make this cooperate with the browser's native
               click handling in every ordering:
               1. v.played: a video with ANY played time is the user's to
                  control (native pause acts inside the shadow DOM before
                  this bubbled click arrives — "paused" alone would restart
                  a just-paused video).
               2. setTimeout(0): Chrome toggles play/pause on video-body
                  clicks as the click's DEFAULT ACTION, which runs after
                  this handler. Starting the video here directly made the
                  native toggle flip it straight back to paused (desktop
                  first-click dead; Safari has no body toggle, so iPhone
                  worked). Deferring past the default action means: if the
                  native toggle started it, we do nothing; if it did
                  nothing (e.g. metadata still loading), we start it. The
                  click's transient user activation still covers the
                  deferred play(), so sound is permitted. */
            if (v && v.paused && v.played.length === 0) {
              setTimeout(() => {
                if (v.paused && v.played.length === 0) {
                  v.play().catch(() => {});
                }
              }, 0);
            }
          });
        }

        this.hoverZone = this.querySelector('[data-hover-zone]');
        this.content = this.querySelector('[data-content]');
        this.background = this.querySelector('[data-background]');
        this.subheading = this.querySelector('[data-subheading]');
        this.headline = this.querySelector('[data-headline]');
        this.body = this.querySelector('[data-body]');
        this.link = this.querySelector('[data-link]');
        this.classList.toggle('has-link', !!this.link);
        this.expander = this.querySelector('[data-expander]');

        // Click anywhere on the hero to open the link (desktop + mobile)
        this.addEventListener('click', (e) => {
          if (!this.link) return;
          if (e.target.closest('[data-link]')) return;
          // Clicks on a video with native controls (click-to-play) must reach
          // the native controls instead of opening the link. Autoplay videos
          // have no controls — those should still navigate like the rest of
          // the hero.
          const clickedVideo = e.target.closest('video');
          if (clickedVideo && clickedVideo.hasAttribute('controls')) return;

          // Don't navigate if the user has a text selection (they're copying text)
          const sel = window.getSelection && window.getSelection();
          if (sel && sel.toString().length > 0) return;

          // On mobile with body text, the text block tap-toggles the expander
          if (window.innerWidth < 990 && this.body && e.target.closest('[data-content]')) return;

          e.preventDefault();
          this.openLink_();
        });

        setTimeout(() => this.updatePositions(), 100);
        window.addEventListener('resize', () => this.updatePositions());

        // Hover state is a composite of two independent triggers: mouse
        // hover over the TEXT BLOCK or its LINK, and a desktop scroll-
        // position trigger (analogous to mobile). Either being true
        // engages .hover-active. The bottom-strip hover-zone NO LONGER
        // toggles state — we deliberately removed its mouseenter/leave
        // listeners. The hover-zone element remains in the DOM because
        // video-engaged CSS targets it and clicks bubble through it.
        this.isHovering = false;
        this.isScrollActive = false;
        const updateHoverActive = () => {
          this.classList.toggle('hover-active', this.isHovering || this.isScrollActive);
        };
        const setHover = (on) => {
          this.isHovering = on;
          updateHoverActive();
        };

        const syncHover = () => {
          const overLink = this.link && this.link.matches(':hover');
          const overContent = this.content && this.content.matches(':hover');
          setHover(!!(overLink || overContent));
        };

        if (this.link) {
          this.link.addEventListener('mouseenter', () => setHover(true));
          this.link.addEventListener('mouseleave', () => setTimeout(syncHover, 0));
        }

        // Content sits above hoverZone (so text is selectable); track hover here too
        // so moving the cursor onto the text doesn't collapse the panel.
        // Desktop only — iOS simulates mouseenter on tap, which would force hover-active
        // and prevent the mobile expander toggle from visually closing.
        if (this.content) {
          this.content.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 990) setHover(true);
          });
          this.content.addEventListener('mouseleave', () => {
            if (window.innerWidth >= 990) setTimeout(syncHover, 0);
          });
        }

        // Click handler — when body text exists, tapping the content area
        // toggles the FULL expand state (.mobile-expanded), which reveals
        // the body and rotates the + icon. The scroll-position handler
        // below is independent and only engages the BACKGROUND.
        if (this.body && this.content) {
          this.content.addEventListener('click', (e) => {
            if (e.target.closest('[data-link]')) return;
            if (window.innerWidth < 990) {
              this.setMobileExpanded_(!this.isMobileExpanded);
            }
          });
        }

        // Mobile scroll-position-driven BACKGROUND-ONLY reveal. ALWAYS runs
        // (regardless of body presence). Toggles .mobile-bg-engaged when
        // the text block's centre crosses 45% from the viewport top. This
        // is independent of .mobile-expanded — both can coexist:
        //  • Scroll past threshold → .mobile-bg-engaged: background up,
        //    colours shift, link arrow shows. Body stays hidden, + stays +.
        //  • Click + (body case)    → .mobile-expanded: body reveals, + rotates.
        //  • Scroll back            → .mobile-bg-engaged removed; if also
        //    not .mobile-expanded, background slides back down.
        const mobileTextEl = this.content || this.headline || this;
        const mobileBgScrollUpdate = () => {
          if (window.innerWidth >= 990) {
            if (this.classList.contains('mobile-bg-engaged')) {
              this.classList.remove('mobile-bg-engaged');
            }
            return;
          }
          const rect = mobileTextEl.getBoundingClientRect();
          const vh = window.innerHeight || document.documentElement.clientHeight;
          const textCenter = rect.top + rect.height / 2;
          const threshold = vh * 0.45;
          this.classList.toggle('mobile-bg-engaged', textCenter < threshold);
        };
        window.addEventListener('scroll', mobileBgScrollUpdate, { passive: true });
        window.addEventListener('resize', mobileBgScrollUpdate);
        mobileBgScrollUpdate();

        // Desktop scroll-position-driven background reveal — mirrors the
        // mobile no-body version above but ALWAYS active on desktop
        // (regardless of body presence). .hover-active is set when the
        // text block's centre crosses 45% from the viewport top. It
        // composes with mouse-hover via updateHoverActive, so either
        // trigger keeps the panel engaged and releasing one doesn't
        // collapse the panel if the other is still true. No-op below
        // 990px — the mobile branches above own that range.
        {
          const textEl = this.content || this.headline || this;
          const desktopScrollUpdate = () => {
            if (window.innerWidth < 990) {
              if (this.isScrollActive) {
                this.isScrollActive = false;
                updateHoverActive();
              }
              return;
            }
            const rect = textEl.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const textCenter = rect.top + rect.height / 2;
            const threshold = vh * 0.45;
            this.isScrollActive = textCenter < threshold;
            updateHoverActive();
          };
          window.addEventListener('scroll', desktopScrollUpdate, { passive: true });
          window.addEventListener('resize', desktopScrollUpdate);
          desktopScrollUpdate();
        }
      }

      openLink_() {
        if (!this.link) return;
        const href = this.link.getAttribute('href');
        if (!href) return;
        const newTab = this.link.getAttribute('target') === '_blank';
        if (newTab) {
          window.open(href, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = href;
        }
      }

      setMobileExpanded_(expanded) {
        if (this.isMobileExpanded === expanded) return;
        this.isMobileExpanded = expanded;
        this.classList.toggle('mobile-expanded', expanded);
        if (this.expander) {
          this.expander.setAttribute('aria-expanded', expanded);
          this.expander.setAttribute('aria-label', expanded ? 'Collapse content' : 'Expand content');
        }
        setTimeout(() => this.updatePositions(), 50);
      }

      updatePositions() {
        if (window.innerWidth >= 990) {
          if (this.content && this.hoverZone && this.background) {
            const linkH = this.link ? this.link.offsetHeight : 0;
            this.content.style.setProperty('--ai-link-h', linkH + 'px');

            let bodyRestHeight = 0;
            if (this.body) {
              const bodyStyles = window.getComputedStyle(this.body);
              const bodyFontSize = parseFloat(bodyStyles.fontSize);
              const bodyLineHeight = parseFloat(bodyStyles.lineHeight);
              const bodyPaddingTop = parseFloat(bodyStyles.paddingTop);
              const firstLineHeight = bodyLineHeight || (bodyFontSize * 1.5);
              bodyRestHeight = this.body.offsetHeight - firstLineHeight - bodyPaddingTop;
            }

            const linkGapNudge = this.link ? (this.body ? 14 : 0) : 0;

            if (!this.isHovering) {
              this.content.style.transform = `translateY(${bodyRestHeight + linkGapNudge}px)`;
            } else {
              this.content.style.transform = `translateY(0)`;
            }

            const contentHeight = this.content.offsetHeight;
            this.background.style.height = contentHeight + 'px';
            this.background.style.width = (this.content.offsetLeft + this.content.offsetWidth) + 'px';

            const containerRect = this.getBoundingClientRect();
            const contentRect = this.content.getBoundingClientRect();
            const hoverZoneHeight = containerRect.bottom - contentRect.top + bodyRestHeight;
            this.hoverZone.style.height = Math.max(hoverZoneHeight, 100) + 'px';
          }
        } else {
          if (this.background && this.content) {
            const linkH = this.link ? this.link.offsetHeight : 0;
            this.content.style.setProperty('--ai-link-h', linkH + 'px');
            const bodyHeight = this.body ? this.body.scrollHeight : 0;

            // Expose bodyHeight as a CSS variable so the .mobile-bg-engaged
            // rule can shift the background down by that amount when only
            // the background is engaged (no body expansion). Read inside
            // .ai-hero-banner.mobile-bg-engaged:not(.mobile-expanded)
            // .ai-hero-banner__background { transform: translateY(var(--mobile-body-h)) }
            this.style.setProperty('--mobile-body-h', bodyHeight + 'px');

            if (!this.isMobileExpanded) {
              this.content.style.transform = `translateY(${bodyHeight}px)`;
            } else {
              this.content.style.transform = `translateY(0)`;
            }

            const contentHeight = this.content.scrollHeight;
            this.background.style.height = contentHeight + 'px';
            this.background.style.width = '100%';
          }
        }
      }
    }

    const _define = () => customElements.define('edge-to-edge-hero', EdgeToEdgeHero);
    if ('requestIdleCallback' in window) {
      requestIdleCallback(_define);
    } else {
      setTimeout(_define, 100);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
